import script from "./VinificationTimelinePage.vue?vue&type=script&setup=true&lang=js"
export * from "./VinificationTimelinePage.vue?vue&type=script&setup=true&lang=js"

import "./VinificationTimelinePage.vue?vue&type=style&index=0&id=73b779c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73b779c7"]])

export default __exports__